export default (theBeverage, cartItem) => {
    
    let itemPrice = 0.00;

    // get the price for the size
    theBeverage.prices.forEach((thePrice) => {
        if (thePrice.id == cartItem.price_id) {
            itemPrice += parseFloat(thePrice.price);
        }
    });

    itemPrice *= cartItem.quantity;
    
    return itemPrice;
}